import { PostType } from '@tribeplatform/gql-client/types'
import { EntityImage } from '@tribeplatform/react-components/common/components'
import { useRouter } from '@tribeplatform/react-sdk'

import { useSiteTreeContext } from '../contexts/SiteTreeContext.js'

import { CMSMenu } from './CMSMenu.js'

export function CMSTreeItem({ postType }: { postType: PostType }) {
  const { Link } = useRouter()
  const context = useSiteTreeContext()

  const to = context.cms?.to?.(postType)
  const showMenu = context.cms?.showMenu

  return (
    <div className="flex items-center justify-between gap-2 p-2 size-full">
      <Link
        className="flex items-center gap-2 min-w-0"
        href={to}
        onClick={context.onItemSelect}
      >
        <EntityImage
          size="lg"
          entity={{ image: postType.icon, name: postType.name }}
        />
        <span className="truncate">{postType.name}</span>
      </Link>
      {showMenu && (
        <div className="flex items-center">
          <CMSMenu postType={postType} />
        </div>
      )}
    </div>
  )
}
